import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const RenderMonthlyLevelChart = function({ minByMonth, maxByMonth, meanByMonth }) {
  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  // Prepare the data for Recharts
  const data = months.map((month, index) => ({
    month,
    min: minByMonth[index],
    mean: meanByMonth[index],
    max: maxByMonth[index]
  }));

  return (
    <ResponsiveContainer width="100%" height={280}>
      <LineChart
        data={data}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis width={80} tickFormatter={(value) => `${value} m`} />
        <Tooltip formatter={(value) => `${value} m`} />
        <Legend formatter={(value) => `${value} (m)`} />
        <Line type="monotone" dataKey="min" stroke="#4a49a6" name="Min Level" />
		<Line type="monotone" dataKey="mean" stroke="#388e3c" name="Mean Level" />
		<Line type="monotone" dataKey="max" stroke="#e65100" name="Max Level" />

      </LineChart>
    </ResponsiveContainer>
  );
};

export default RenderMonthlyLevelChart;
